var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C6.06099 1.25 1.25 6.06099 1.25 12C1.25 17.939 6.06099 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22C12.75 21.5858 12.4142 21.25 12 21.25C6.88941 21.25 2.75 17.1106 2.75 12C2.75 6.88941 6.88942 2.75 12 2.75C17.1106 2.75 21.25 6.88942 21.25 12C21.25 12.5421 21.2087 13.0602 21.1352 13.556L19.2724 11.0042C19.0282 10.6696 18.559 10.5964 18.2245 10.8406C17.8899 11.0848 17.8167 11.554 18.0609 11.8886L20.8983 15.7755C21.0663 16.0057 21.3502 16.1207 21.631 16.0725C21.9118 16.0243 22.141 15.8211 22.2226 15.5481C22.5405 14.4843 22.75 13.3045 22.75 12C22.75 6.06099 17.939 1.25 12 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.99999C12.75 7.69664 12.5673 7.42317 12.287 7.30708C12.0068 7.19099 11.6842 7.25516 11.4697 7.46966L8.46967 10.4697C8.17678 10.7626 8.17678 11.2374 8.46967 11.5303C8.76256 11.8232 9.23744 11.8232 9.53033 11.5303L11.25 9.81065V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V7.99999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatOne);
export default __webpack_public_path__ + "static/media/repeat-one.1486d135c5d94b8eca8d23d5e947d8f5.svg";
export { ForwardRef as ReactComponent };